module.exports = __webpack_public_path__ + "static/media/sobre.06285c9a.jpg";